import { businessPlanAxios } from 'services/controllers/businessPlan';

import { IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

import * as t from './types';

export const ExpensesApi = {
  getExpensesCalculationsByCategory: async (params: t.IGetExpensesCalculationsParams) => {
    const { businessPlanId, unit, generalExpenseData } = params;
    const { data } = await businessPlanAxios.put<t.IGetExpensesCalculationResponse>(
      `/${businessPlanId}/generalexpense/${unit}`,
      generalExpenseData
    );
    return data;
  },
  
  getExpensesByProduct: async (params: t.IGetExpensesCalculationsByProductParams) => {
    const { businessPlanId, unit, expenseData } = params;
    const { data } = await businessPlanAxios.put<IPeriodsTableRow>(
      `/${businessPlanId}/product/update/generalexpense/${unit}`,
      expenseData
    );
    return data;
  },

  getExpensesRecalculationsByCategory: async (params: t.IGetExpensesRecalculationsParams) => {
    const { businessPlanId, unit, generalExpenseData } = params;
    const { data } = await businessPlanAxios.put<t.IGetExpensesCalculationResponse>(
      `/${businessPlanId}/generalexpense/recalculate/${unit}`,
      generalExpenseData
    );
    return data;
  },
};
